import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { fullWidth } from "components/Design/ArtDirectedImage";
import ConditionalLink from "components/ConditionalLink";
import Icon from "components/CommonIcon/Icon";
import "./style.less";

const CardHotel = ({ logo, title, to }) => {
  return (
    <ConditionalLink link={to} className="w-full block card-hotel">
      <div className="flex items-center space-x-14">
        <div className="w-50 h-50 flex items-center justify-center shrink-0">
          <GatsbyImage
            image={fullWidth(logo)}
            className="w-full h-full"
            loading="lazy"
          />
        </div>
        <div className="card-hotel-text flex items-center justify-between w-full">
          <h2 className="text-14-22 text-gray-text font-normal">{title}</h2>
          <Icon name="right-arrow-thin" fontSize="text-20" />
        </div>
      </div>
    </ConditionalLink>
  );
};

const CardHotelList = ({ children }) => {
  return <div className="card-hotel-list w-240 normal-case">{children}</div>;
};

export { CardHotel, CardHotelList };
